import React, { useState, useEffect } from "react";

const useMultiAudio = (urls) => {
  const [sources] = useState(
    urls.map((url) => {
      return {
        url,
        audio: new Audio(url),
      };
    })
  );

  const [players, setPlayers] = useState(
    urls.map((url) => {
      return {
        url,
        playing: false,
      };
    })
  );

  const handlePlay = (targetIndex) => () => {
    const newPlayers = [...players];
    const currentIndex = players.findIndex((p) => p.playing === true);
    if (currentIndex !== -1 && currentIndex !== targetIndex) {
      newPlayers[currentIndex].playing = false;
      newPlayers[targetIndex].playing = true;
    } else if (currentIndex !== -1) {
      newPlayers[targetIndex].playing = false;
    } else {
      newPlayers[targetIndex].playing = true;
    }
    setPlayers(newPlayers);
  };

  useEffect(() => {
    sources.forEach((source, i) => {
      players[i].playing ? source.audio.play() : source.audio.pause();
    });
  }, [sources, players]);

  useEffect(() => {
    sources.forEach((source, i) => {
      source.audio.addEventListener("ended", () => {
        const newPlayers = [...players];
        newPlayers[i].playing = false;
        setPlayers(newPlayers);
      });
    });
    return () => {
      sources.forEach((source, i) => {
        source.audio.removeEventListener("ended", () => {
          const newPlayers = [...players];
          newPlayers[i].playing = false;
          setPlayers(newPlayers);
        });
      });
    };
  }, []);

  return [players, handlePlay];
};

const Player = ({ player, handlePlay }) => (
  <div>
    <p>Stream URL: {player.url}</p>
    <button onClick={handlePlay}>{player.playing ? "Pause" : "Play"}</button>
  </div>
);

const MultiPlayer = ({ urls }) => {
    const [players, handlePlay] = useMultiAudio(urls)

  console.log("urls-multiplayer", urls);

  return (
    <div>
      {players.map((player, i) => (
            <Player key={i} player={player} handlePlay={handlePlay(i)} />
          ))}
    </div>
  );
};

export default MultiPlayer;
